import { clowncar, core } from 'types';
import { toJSONArray } from '@tock/coretypes';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import _ from 'lodash';

interface State {
  businessesRequiringVerification: core.Business[];
  businessVerifications: { [businessId: number]: clowncar.BusinessVerification[] };
  isInitialized: boolean;
  requestInProgress: boolean;
}

const initialState: State = {
  businessesRequiringVerification: [],
  businessVerifications: {},
  isInitialized: false,
  requestInProgress: false,
};

export default function reducer(state: State = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case ClowncarAppConstants.VERIFICATIONS_REQUIRED_STARTING: {
      return {
        ...state,
        businessesRequiringVerifications: [],
        businessVerifications: {},
        isInitialized: false,
        requestInProgress: true,
      };
    }
    case ClowncarAppConstants.VERIFICATION_EVIDENCE_UPLOAD_STARTING:
    case ClowncarAppConstants.VERIFICATION_ACCEPT_EVIDENCE_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case ClowncarAppConstants.VERIFICATIONS_REQUIRED_DONE: {
      const jsonPayload: clowncar.BusinessVerification[] = toJSONArray(payload);
      const businessesRequiringVerification = _.uniqBy(
        _.map(jsonPayload, (verification) => verification.business as core.Business),
        'id'
      );
      const businessVerifications = _.groupBy(
        jsonPayload,
        (verification) => verification.business?.id
      );
      return {
        ...state,
        requestInProgress: false,
        isInitialized: true,
        businessesRequiringVerification,
        businessVerifications,
      };
    }
    case ClowncarAppConstants.VERIFICATION_ACCEPT_EVIDENCE_DONE:
    case ClowncarAppConstants.VERIFICATION_ACCEPT_EVIDENCE_FAILED:
    case ClowncarAppConstants.VERIFICATION_EVIDENCE_UPLOAD_DONE:
    case ClowncarAppConstants.VERIFICATION_EVIDENCE_UPLOAD_FAILED:
    case ClowncarAppConstants.VERIFICATIONS_REQUIRED_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    default:
      return state;
  }
}
